"use client"

import { useRef, useState, useEffect } from "react"
import { Button } from "antd"
import { LeftOutlined, RightOutlined } from "@ant-design/icons"
import { StyledWrapper } from '@/components/Styled'

export default function CaseStudies({ props }: any) {
  const scrollContainerRef = useRef<HTMLDivElement>(null)
  const [scrollPosition, setScrollPosition] = useState(0)
  const [maxScroll, setMaxScroll] = useState(0)
// console.log('studies are ',props)
  useEffect(() => {
    const updateScrollLimits = () => {
      if (scrollContainerRef.current) {
        setMaxScroll(scrollContainerRef.current.scrollWidth - scrollContainerRef.current.clientWidth)
      }
    }

    updateScrollLimits()
    window.addEventListener("resize", updateScrollLimits)

    return () => window.removeEventListener("resize", updateScrollLimits)
  }, [])

  const handleScroll = () => {
    if (scrollContainerRef.current) {
      setScrollPosition(scrollContainerRef.current.scrollLeft)
    }
  }

  const scrollTo = (direction: "left" | "right") => {
    if (scrollContainerRef.current) {
      const container = scrollContainerRef.current
      const scrollAmount = container.clientWidth * 0.8
      container.scrollBy({ left: direction === "left" ? -scrollAmount : scrollAmount, behavior: "smooth" })
    }
  }

  return (
    <div className="w-full bg-gray-50 py-10 xl:py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-4 text-center">
          {
            props?.title|| ''
          }
        </h2>
        <StyledWrapper>
        <div className="text-xl text-gray-600 mb-12 text-center max-w-3xl mx-auto" dangerouslySetInnerHTML={{__html:   props?.description ||""}}>
        </div>
        </StyledWrapper>
        <div className="relative">
          {/* Left Button */}
          <div className="absolute left-0 top-1/2 transform -translate-y-1/2 -translate-x-4 z-10">
            <Button
              type="primary"
              icon={<LeftOutlined />}
              className="bg-blue hover:bg-blue rounded-full h-[40px] min-w-[40px] border-none shadow-lg"
              disabled={scrollPosition === 0}
              onClick={() => scrollTo("left")}
            />
          </div>

          {/* Scrollable Case Studies */}
          <StyledWrapper>
          <div
            ref={scrollContainerRef}
            onScroll={handleScroll}
            className="flex overflow-x-auto  h-fit gap-6 pb-8 hide-scrollbar "
            style={{ scrollSnapType: "x mandatory", scrollbarWidth: "none" }}>
            {props?.card?.map((study:any, index:number) => (
              <div
                key={index}
                className="w-full max-h-[60vh] overflow-auto sm:w-[calc(100%-2rem)] 
                md:w-[calc(50%-1rem)] lg:w-[calc(50%-1rem)] flex-shrink-0 bg-white rounded-xl shadow-lg p-6 transition-all duration-300 hover:shadow-xl"
                style={{ scrollSnapAlign: "start" }}
                dangerouslySetInnerHTML={{ __html: study.content }}/>
            ))}
          </div>
          </StyledWrapper>

          {/* Right Button */}
          <div className="absolute right-0 top-1/2 transform -translate-y-1/2 translate-x-4 z-10">
            <Button
              type="primary"
              icon={<RightOutlined />}
              className="bg-blue hover:bg-blue rounded-full h-[40px] min-w-[40px] border-none shadow-lg"
              disabled={scrollPosition >= maxScroll}
              onClick={() => scrollTo("right")}
            />
          </div>
        </div>
        <StyledWrapper>

        <div className="text-xl text-gray-600 lg:mb-12 text-center max-w-3xl mx-auto" dangerouslySetInnerHTML={{__html:   props?.content ||""}}>
        </div>
        </StyledWrapper>
      </div>
    </div>
  )
}
